<template>
  <router-view/>
	<section class="popup-area"></section>
</template>

<style lang="scss">
@use "@/scss/ui/popup/popup-area";
</style>
